var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500", persistent: "" },
      model: {
        value: _vm.dialogVisible,
        callback: function ($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible",
      },
    },
    [
      _vm.receipt
        ? _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text py-3" },
                [
                  _c("v-icon", { attrs: { left: "", dark: "" } }, [
                    _vm._v("mdi-receipt"),
                  ]),
                  _vm._v(" Comprovante de Registro de Ponto "),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pa-3 mb-4 text-center",
                      attrs: { color: "primary", dark: "", rounded: "" },
                    },
                    [
                      _c("div", { staticClass: "caption" }, [
                        _vm._v("NSR - Número Sequencial do Registro"),
                      ]),
                      _c("div", { staticClass: "text-h4 font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.receipt.nsr || "N/A")),
                      ]),
                    ]
                  ),
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pa-3 mb-4 text-center",
                      attrs: { color: "blue lighten-5", rounded: "" },
                    },
                    [
                      _c("div", { staticClass: "text-h6 primary--text" }, [
                        _vm._v(_vm._s(_vm.receipt.datetime?.date || "N/A")),
                      ]),
                      _c("div", { staticClass: "text-h4 font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.receipt.datetime?.time || "N/A")),
                      ]),
                      _c("div", { staticClass: "caption grey--text" }, [
                        _vm._v(
                          "Fuso horário: " +
                            _vm._s(_vm.receipt.timezone || "America/Sao_Paulo")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "v-list-item",
                    { staticClass: "px-0", attrs: { "two-line": "" } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("mdi-account"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-subtitle", [_vm._v("Trabalhador")]),
                          _c(
                            "v-list-item-title",
                            { staticClass: "font-weight-medium" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.receipt.worker?.name || "N/A") +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-list-item-subtitle", [
                            _vm._v(
                              " CPF: " +
                                _vm._s(
                                  _vm.receipt.worker?.cpf_masked || "N/A"
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-2" }),
                  _c(
                    "v-list-item",
                    { staticClass: "px-0", attrs: { "two-line": "" } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("mdi-domain"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-subtitle", [_vm._v("Empregador")]),
                          _c(
                            "v-list-item-title",
                            { staticClass: "font-weight-medium" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.receipt.employer?.name || "N/A") +
                                  " "
                              ),
                            ]
                          ),
                          _c("v-list-item-subtitle", [
                            _vm._v(
                              " CNPJ: " +
                                _vm._s(_vm.receipt.employer?.cnpj || "N/A") +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-2" }),
                  _c(
                    "v-list-item",
                    { staticClass: "px-0", attrs: { "two-line": "" } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("mdi-map-marker"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-subtitle", [_vm._v("Local")]),
                          _c(
                            "v-list-item-title",
                            { staticClass: "font-weight-medium text-wrap" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.receipt.location || "N/A") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-2" }),
                  _c(
                    "v-list-item",
                    { staticClass: "px-0", attrs: { "two-line": "" } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("mdi-cellphone-link"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-subtitle", [
                            _vm._v("Coletor / Dispositivo"),
                          ]),
                          _c(
                            "v-list-item-title",
                            { staticClass: "font-weight-medium" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.receipt.collector?.ip || "N/A") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-2" }),
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pa-3 mt-4",
                      attrs: { color: "orange lighten-5", rounded: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "caption orange--text text--darken-2 font-weight-medium mb-1",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { small: "", color: "orange darken-2" },
                            },
                            [_vm._v("mdi-shield-check")]
                          ),
                          _vm._v(" Assinatura Digital (SHA-256) "),
                        ],
                        1
                      ),
                      _c(
                        "code",
                        {
                          staticClass: "d-block text-caption",
                          staticStyle: { "word-break": "break-all" },
                        },
                        [_vm._v(" " + _vm._s(_vm.receipt.hash || "N/A") + " ")]
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-4 mb-0 caption",
                      attrs: { type: "info", dense: "", text: "" },
                    },
                    [
                      _vm._v(
                        " Este comprovante atende aos requisitos da Portaria MTP nº 671/2021. A assinatura digital garante a integridade deste registro. "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _vm.downloadError
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mx-4 mt-3 mb-0",
                      attrs: { type: "error", dense: "", outlined: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.downloadError) + " ")]
                  )
                : _vm._e(),
              _c(
                "v-card-actions",
                { staticClass: "pa-4" },
                [
                  _vm.receipt.pdf_url
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            outlined: "",
                            loading: _vm.downloading,
                            disabled: _vm.downloading,
                          },
                          on: { click: _vm.downloadPdf },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                          _vm._v(" Baixar PDF "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { color: "primary" }, on: { click: _vm.close } },
                    [_vm._v(" Fechar ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }